module.exports = __webpack_public_path__ + "img/logo_simple.e5f10b7d.svg";